export const get = <TObject extends Record<string, any>>(
  object: TObject | null | undefined,
  path: string,
  defaultValue: any = undefined,
): any => {
  const travel = (regexp: RegExp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res: any, key: string) =>
          res !== null && res !== undefined ? res[key] : res,
        object,
      )

  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/)
  return result === undefined || result === object ? defaultValue : result
}
